export default "__VITE_ASSET__859a4bf3__"